export default function parseSentenceCase(s: string): string {
  const str = s.toLowerCase();
  return str.split(/(?=[A-Z])/).map(p => p.charAt(0).toUpperCase() + p.slice(1))
    .join(' ');
}
